// Tracks the real assets the opening needs (fonts, page load, the 3D crest)
// so the preloader can show an honest percentage.

type Listener = () => void

type Task = {
    weight: number
    done: boolean
}

const tasks = new Map<string, Task>()
const listeners = new Set<Listener>()

const notify = (): void => listeners.forEach(listener => listener())

export const registerAsset = (name: string, weight = 1): void => {
    if (tasks.has(name)) return

    tasks.set(name, { weight, done: false })
    notify()
}

export const completeAsset = (name: string): void => {
    const task = tasks.get(name)

    if (!task) {
        tasks.set(name, { weight: 1, done: true })
        notify()
        return
    }

    if (task.done) return

    task.done = true
    notify()
}

export const assetProgress = (): number => {
    let total = 0
    let done = 0

    tasks.forEach(task => {
        total += task.weight
        if (task.done) done += task.weight
    })

    return total === 0 ? 0 : done / total
}

export const subscribeAssets = (listener: Listener): (() => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}
